import { Pipe, PipeTransform } from '@angular/core';
import { FourThreeWayValvePositoin } from './internal-hydraulic.model';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'internalHydraulicTranslations',
})
export class InternalHydraulicTranslationsPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}
  transform(value: string): string {
    switch (value) {
      case FourThreeWayValvePositoin.climateCircuitOne:
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.FOUR_THREE_WAY_VALVE_POSITION.CLIMATE_CIRCUIT_ONE'
        );
      case FourThreeWayValvePositoin.climatCircuitTwoDefrost:
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.FOUR_THREE_WAY_VALVE_POSITION.CLIMAT_CIRCUIT_TWO_DEFROST'
        );
      case FourThreeWayValvePositoin.domesticHotWater:
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.FOUR_THREE_WAY_VALVE_POSITION.DOMESTIC_HOT_WATER'
        );
      case FourThreeWayValvePositoin.climatCircuitOneAndTwo:
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.FOUR_THREE_WAY_VALVE_POSITION.CLIMAT_CIRCUIT_ONE_AND_TWO'
        );
      case FourThreeWayValvePositoin.climateCircuitTwoDefrostDomesticHotWater:
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.FOUR_THREE_WAY_VALVE_POSITION.CLIMATE_CIRCUIT_TWO_DEFROST_DOMESTIC_HOT_WATER'
        );
      default:
        return value;
    }
  }
}
